module.exports = __webpack_public_path__ + "static/media/main idea.c8e56cf2.mp3";